import type {VoidFunctionComponent} from "react";
import React from "react";
import s from "./MusicHomeMobileSearchControlAccess.module.scss";
import {useMusicHomeMobileSearchControlAccessLogic} from "./MusicHomeMobileSearchControlAccess.logic";
import {FontIcon} from "../../../../../../components/common/FontIcon";

export const MusicHomeMobileSearchControlAccess: VoidFunctionComponent = () => {
  const useSearchClasses = [
    s.titlebarButton,
  ];
  const {
    isMobileSearchActive,
    handleMobileSearchDisplayToggle,
  } = useMusicHomeMobileSearchControlAccessLogic();

  if (isMobileSearchActive) {
    useSearchClasses.push(s.searchActive);
  }

  return (
    <div className={s.container}>
      <button className={useSearchClasses.join(` `)} aria-label={"Search"} onClick={handleMobileSearchDisplayToggle}>
        <FontIcon icon={"icon-search"}/>
      </button>
    </div>
  );
}
